import {
  CL009_COUNTRY_CODES_COMMON_TRANSIT,
  MODE_OF_TRANSPORT_EXPRESS_ROAD,
} from 'shared/ncts/common/constants'
import { COUNTRY_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0003Validator = {
  validateConsignmentConsigneeRequirement: ({
    security,
    specificCircumstanceIndicator,
    isConsignmentConsigneePresent,
    hasConsignmentAdditionalReference30600,
    hasHouseConsignmentAdditionalReference30600,
  }: {
    security: string
    specificCircumstanceIndicator: string
    isConsignmentConsigneePresent: boolean
    hasConsignmentAdditionalReference30600?: boolean
    hasHouseConsignmentAdditionalReference30600?: boolean
  }): RuleResult => {
    if (['1', '3'].includes(security)) {
      return specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (hasConsignmentAdditionalReference30600) return 'NOT_ALLOWED'
    if (hasHouseConsignmentAdditionalReference30600) return 'NOT_ALLOWED'

    return isConsignmentConsigneePresent ? 'REQUIRED' : 'OPTIONAL'
  },
  validateHouseConsignmentConsigneeRequirement: ({
    security,
    specificCircumstanceIndicator,
    isConsignmentConsigneePresent,
    countryOfDestination,
    houseCountryOfDestination,
    hasHouseConsignmentWithCtcDestination,
    hasItemWithCtcDestination,
    hasConsignmentAdditionalReference30600,
    hasHouseConsignmentAdditionalReference30600,
  }: {
    security: string
    specificCircumstanceIndicator: string
    isConsignmentConsigneePresent?: boolean
    countryOfDestination?: string
    houseCountryOfDestination?: string
    hasHouseConsignmentWithCtcDestination?: boolean
    hasItemWithCtcDestination?: boolean
    hasConsignmentAdditionalReference30600?: boolean
    hasHouseConsignmentAdditionalReference30600?: boolean
  }) => {
    if (['1', '3'].includes(security)) {
      return specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD ? 'REQUIRED' : 'NOT_ALLOWED'
    }

    const country = removePrefix(countryOfDestination, COUNTRY_CODE_PREFIX) ?? ''
    if (CL009_COUNTRY_CODES_COMMON_TRANSIT.includes(country)) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    const houseCountry = removePrefix(houseCountryOfDestination, COUNTRY_CODE_PREFIX) ?? ''
    if (CL009_COUNTRY_CODES_COMMON_TRANSIT.includes(houseCountry)) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (hasHouseConsignmentWithCtcDestination) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (hasItemWithCtcDestination) {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'REQUIRED'
    }

    if (security === '0') {
      return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'OPTIONAL'
    }

    if (hasConsignmentAdditionalReference30600) return 'NOT_ALLOWED'
    if (hasHouseConsignmentAdditionalReference30600) return 'NOT_ALLOWED'

    return isConsignmentConsigneePresent ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0003Validator
